import { SVGProps, Ref, forwardRef } from 'react';

export const QrCodeOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M6 16c1.5 0 2 1 2 2s-.5 2-2 2-2-1-2-2 .5-2 2-2" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 13c4.375 0 5 .625 5 5s-.625 5-5 5-5-.625-5-5 .625-5 5-5m0 1.8c-1.08 0-1.796.04-2.294.135a2 2 0 0 0-.467.132.4.4 0 0 0-.107.065.4.4 0 0 0-.065.107c-.038.085-.088.23-.132.467C2.84 16.204 2.8 16.92 2.8 18s.04 1.796.135 2.294c.044.237.094.382.132.467.036.077.06.102.065.107s.03.03.107.065c.085.038.23.088.467.132.498.094 1.214.135 2.294.135s1.796-.04 2.294-.135c.237-.044.382-.094.467-.132a.4.4 0 0 0 .107-.065.4.4 0 0 0 .065-.107c.038-.085.088-.23.132-.467.094-.498.135-1.214.135-2.294s-.04-1.796-.135-2.294a2 2 0 0 0-.132-.467.4.4 0 0 0-.065-.107.4.4 0 0 0-.107-.065 2 2 0 0 0-.467-.132C7.796 14.84 7.08 14.8 6 14.8"
                fill="currentColor"
            />
            <path
                d="M15 19.5c1.125 0 1.5.75 1.5 1.5s-.375 1.5-1.5 1.5-1.5-.75-1.5-1.5.375-1.5 1.5-1.5"
                fill="currentColor"
            />
            <path
                d="M21 19.5c1.125 0 1.5.75 1.5 1.5s-.375 1.5-1.5 1.5-1.5-.75-1.5-1.5.375-1.5 1.5-1.5"
                fill="currentColor"
            />
            <path
                d="M18 16.5c1.125 0 1.5.75 1.5 1.5s-.375 1.5-1.5 1.5-1.5-.75-1.5-1.5.375-1.5 1.5-1.5"
                fill="currentColor"
            />
            <path
                d="M15 13.5c1.125 0 1.5.75 1.5 1.5s-.375 1.5-1.5 1.5-1.5-.75-1.5-1.5.375-1.5 1.5-1.5"
                fill="currentColor"
            />
            <path
                d="M21 13.5c1.125 0 1.5.75 1.5 1.5s-.375 1.5-1.5 1.5-1.5-.75-1.5-1.5.375-1.5 1.5-1.5"
                fill="currentColor"
            />
            <path d="M6 4c1.5 0 2 1 2 2s-.5 2-2 2-2-1-2-2 .5-2 2-2" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 1c4.375 0 5 .625 5 5s-.625 5-5 5-5-.625-5-5 .625-5 5-5m0 1.8c-1.08 0-1.796.04-2.294.135a2 2 0 0 0-.467.132.4.4 0 0 0-.107.065.4.4 0 0 0-.065.107 2 2 0 0 0-.132.467C2.84 4.204 2.8 4.92 2.8 6s.04 1.796.135 2.294c.044.237.094.382.132.467a.4.4 0 0 0 .065.107.4.4 0 0 0 .107.065c.085.038.23.088.467.132C4.204 9.16 4.92 9.2 6 9.2s1.796-.04 2.294-.135a2 2 0 0 0 .467-.132.4.4 0 0 0 .107-.065.4.4 0 0 0 .065-.107 2 2 0 0 0 .132-.467C9.16 7.796 9.2 7.08 9.2 6s-.04-1.796-.135-2.294a2 2 0 0 0-.132-.467.4.4 0 0 0-.065-.107.4.4 0 0 0-.107-.065 2 2 0 0 0-.467-.132C7.796 2.84 7.08 2.8 6 2.8"
                fill="currentColor"
            />
            <path d="M18 4c1.5 0 2 1 2 2s-.5 2-2 2-2-1-2-2 .5-2 2-2" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18 1c4.375 0 5 .625 5 5s-.625 5-5 5-5-.625-5-5 .625-5 5-5m0 1.8c-1.08 0-1.796.04-2.294.135a2 2 0 0 0-.467.132.4.4 0 0 0-.107.065.4.4 0 0 0-.065.107c-.038.085-.088.23-.132.467C14.84 4.204 14.8 4.92 14.8 6s.04 1.796.135 2.294c.044.237.094.382.132.467.036.077.06.102.065.107s.03.03.107.065c.085.038.23.088.467.132.498.094 1.214.135 2.294.135s1.796-.04 2.294-.135c.237-.044.382-.094.467-.132a.4.4 0 0 0 .107-.065.4.4 0 0 0 .065-.107c.038-.085.088-.23.132-.467.094-.498.135-1.214.135-2.294s-.04-1.796-.135-2.294a2 2 0 0 0-.132-.467.4.4 0 0 0-.065-.107.4.4 0 0 0-.107-.065 2 2 0 0 0-.467-.132C19.796 2.84 19.08 2.8 18 2.8"
                fill="currentColor"
            />
        </g>
    </svg>
));
QrCodeOutlinedSize24Glyph.displayName = 'QrCodeOutlinedSize24Glyph';
